import { render, staticRenderFns } from "./ConfirmPublishModal.vue?vue&type=template&id=5019b40c&scoped=true&"
import script from "./ConfirmPublishModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmPublishModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPublishModal.vue?vue&type=style&index=0&id=5019b40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019b40c",
  null
  
)

export default component.exports